import React from "react";
import PropTypes from "prop-types";

const icons = {
  clipboard: (
    <>
      <rect x="7" y="5" width="10" height="14" rx="2" />
      <path d="M9 5.5h6V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.5Z" />
      <path d="M10 10h4M10 14h4" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="m8.5 12 2.25 2.25L16 9" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  hourglass: (
    <>
      <path d="M7 4h10M7 20h10M8 4c0 4 1.5 5.5 4 8-2.5 2.5-4 4-4 8M16 4c0 4-1.5 5.5-4 8 2.5 2.5 4 4 4 8" />
    </>
  ),
};

const SummaryCard = ({ item, period }) => (
  <article className={`dashboard-summary-card dashboard-summary-card--${item.tone}`}>
    <div className="dashboard-summary-card__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        {icons[item.icon]}
      </svg>
    </div>
    <div className="dashboard-summary-card__content">
      <span className="dashboard-summary-card__label">{item.label}</span>
      <strong className="dashboard-summary-card__value">{item.value}</strong>
      <span className="dashboard-summary-card__caption">{item.caption}</span>
    </div>
    <span className="dashboard-summary-card__period">{period}</span>
  </article>
);

SummaryCard.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    caption: PropTypes.string.isRequired,
    tone: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
  period: PropTypes.string.isRequired,
};

export default SummaryCard;
